import { HttpClient } from '@angular/common/http';
import { AppConfig, ConfigService } from './services/config.service';
import { tap } from 'rxjs/operators';

export function initializeConfigService(
  http: HttpClient,
  configService: ConfigService
): () => Promise<void> {
  return (): Promise<void> => {
    return http
      .get('/assets/config.json')
      .pipe(
        tap<AppConfig>(config => configService.loadConfig(config))
      )
      .toPromise()
      .then(() => {});
  };
}
